const menuList = [
    {
      url: "gin",
      name: "Gin",
      text: "Lorem ipsum dolor sit"
    },
    {
      url: "vodka",
      name: "Vodka",
      text: "Lorem ipsum dolor sit"
    },
    {
      url: "rum",
      name: "Rum",
      text: "Lorem ipsum dolor sit"
    },
    {
      url: "scotch",
      name: "Scotch",
      text: "Lorem ipsum dolor sit"
    },
    {
      url: "Non_Alcoholic",
      name: "Non-Alcoholic",
      text: "Lorem ipsum dolor sit"
    },
    {
      url: "random",
      name: "Random Drink",
      text: "Lorem ipsum dolor sit"
  },
  {
    url: "search",
    name: "Search",
    text: "Lorem ipsum dolor sit"
  },
]
  
export default menuList